var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#24252d;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1,63.71c1.48-4.05,2.65-7.6,4.08-11a4.07,4.07,0,0,0-.39-4.11A32,32,0,1,1,38.92,63.24a32.4,32.4,0,0,1-21.24-2.55,6.55,6.55,0,0,0-4-.38C9.63,61.24,5.63,62.44,1,63.71Zm6.34-5.79c2.85-.77,5.18-1.51,7.57-2a4.71,4.71,0,0,1,2.91.36c9.63,5.17,19.31,5.37,28.66-.3,9.67-5.88,14.14-14.8,13.5-26.13C59,13.56,43.2,1.23,27.28,4.3c-20.75,4-30,26.81-18,44.29a3.81,3.81,0,0,1,.33,2.77C9,53.42,8.21,55.4,7.33,57.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.1,23.75a10.55,10.55,0,0,1,3.7-7.6,2.7,2.7,0,0,1,4,.08c1.56,1.51,3.11,3,4.63,4.59,1.8,1.84,1.8,3.15,0,5C26.19,28.22,26.23,28.21,28,31a25.11,25.11,0,0,0,8.61,8.07,1.87,1.87,0,0,0,2.7-.33c3.27-3.25,3.81-3.2,7.06.07,1.16,1.17,2.36,2.31,3.49,3.51,1.3,1.34,1.27,2.75,0,4.18-3.19,3.63-7.2,3.86-11.31,2.35-9.45-3.45-16.11-10.15-20.77-18.89C16.85,28.1,16.66,25.83,16.1,23.75Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon5);
export default __webpack_public_path__ + "static/media/card-icon-5.9531bc1da1059522b86c6532cc0882ae.svg";
export { ForwardRef as ReactComponent };